export default __webpack_public_path__ + "b797181c93b3755f4fa1258a4cca14d4.ttf";